// modules
import { useEffect, useMemo } from "react";

// hooks
import { useAppDispatch, useAppSelector } from "app/hooks/hooks";

// redux
import { delinkMember, getCardEnquiryDetailsSelector, getMemberEnquiryDetailsSelector, resetEnquiryDetails } from "redux/userList/userSlice";

// component
import CountDownModal from "components/molecules/ModalContainer/CountDownModalContainer";

// constants & utils
import { getPayloadData } from "utils/getDelinkPayload";
import { VehicleIUDelink as Constants } from "constants/global";

type VehicleIUDelinkPageTypes = { vehicleIUNumber: string; vehicleIUSubmitHandler: (cardNumber?: string, userId?: string, resetForm?: () => void) => Promise<void> };

type DelinkPayload = {
	account: string;
	cr_card_number?: string;
	memberid?: string;
};

export function useVehicleIUDelinkPage(): VehicleIUDelinkPageTypes {
	const dispatch = useAppDispatch();
	const cardEnquiryDetails = useAppSelector(getCardEnquiryDetailsSelector);
	const memberEnquiryDetails = useAppSelector(getMemberEnquiryDetailsSelector);

	const vehicleIUNumber = useMemo(() => {
		if (cardEnquiryDetails) {
			return cardEnquiryDetails?.data?.iu_no;
		}
		if (memberEnquiryDetails) {
			return memberEnquiryDetails?.data?.iu_no;
		}
		return "";
	}, [cardEnquiryDetails, memberEnquiryDetails]);

	useEffect(() => {
		return () => {
			dispatch(resetEnquiryDetails());
		};
	}, []);

	const vehicleIUSubmitHandler = async (cardNumber?: string, userId?: string, resetForm?: () => void) => {
		try {
			const payload: DelinkPayload | undefined = getPayloadData(cardNumber, userId, Constants.ACCOUNT_TYPE);
			if (payload) {
				const { errors, message } = await dispatch(delinkMember(payload)).unwrap();

				if (!errors?.length && message) {
					CountDownModal({
						timer: 3,
						title: message,
						closable: true,
						onTimeComplete: () => {
							dispatch(resetEnquiryDetails());
							resetForm?.();
						}
					});
				}
			}
		} catch (error) {
			const err = error as any;
			if (err?.response?.data?.errors && err?.response?.data?.errors?.length > 0) {
				CountDownModal({
					timer: 3,
					errorIcon: true,
					title: err?.response?.data?.errors?.[0]?.message
				});
			}
		}
	};

	return { vehicleIUNumber, vehicleIUSubmitHandler };
}
